<div class="excel-workspace">

  <!-- =========================================================
       HEADER
  ========================================================== -->
  <header class="workspace-header">

    <div class="header-left">

      <!-- <div class="excel-logo">
        <i class="fa-solid fa-file-excel"></i>
      </div> -->

      <div class="header-content">
        <div class="title-line">
          <h1>Excel Q&A</h1>
        </div>

        <p>
          Import Excel data, configure columns and manage question & answer content.
        </p>
      </div>

    </div>

    <button
      type="button"
      class="history-btn"
      [class.active]="showHistory"
      (click)="toggleHistory()"
    >
      <i class="fa-solid fa-clock-rotate-left"></i>
      <span>History</span>
    </button>

  </header>


  <!-- =========================================================
       PROGRESS
  ========================================================== -->
  <div class="progress-navigation">

    <div class="progress-item active">
      <div class="progress-number">01</div>

      <div>
        <strong>Import</strong>
        <span>Upload Excel</span>
      </div>
    </div>

    <div class="progress-connector"></div>

    <div
      class="progress-item"
      [class.active]="selectedClassList"
    >
      <div class="progress-number">02</div>

      <div>
        <strong>Documents</strong>
        <span>Select files</span>
      </div>
    </div>

    <div class="progress-connector"></div>

    <div
      class="progress-item"
      [class.active]="showsheetform"
    >
      <div class="progress-number">03</div>

      <div>
        <strong>Configure</strong>
        <span>Map columns</span>
      </div>
    </div>

    <div class="progress-connector"></div>

    <div
      class="progress-item"
      [class.active]="showsheetDataList"
    >
      <div class="progress-number">04</div>

      <div>
        <strong>Review</strong>
        <span>Verify Q&A</span>
      </div>
    </div>

  </div>


  <!-- =========================================================
       CONTENT
  ========================================================== -->
  <main class="workspace-content">


    <!-- =======================================================
         IMPORT AREA
    ======================================================== -->
    <section class="import-layout">

      <!-- Upload -->
      <div class="import-panel">

        <div class="panel-heading">

          <div class="heading-icon excel">
            <i class="fa-solid fa-file-arrow-up"></i>
          </div>

          <div>
            <!-- <span>IMPORT DATA</span> -->
            <h2>Upload Excel workbook</h2>
            <p>
              Import your questions and answers from an Excel file.
            </p>
          </div>

        </div>


        <input
          #elibraryFileInput
          type="file"
          id="uploadfile"
          hidden
          accept=".xlsx"
          (change)="chooseUploadFile($event)"
        />


        <div
          class="drop-zone"
          (click)="elibraryFileInput.click()"
        >

          <div class="drop-icon">
            <i class="fa-solid fa-file-excel"></i>

            <div class="drop-plus">
              <i class="fa-solid fa-plus"></i>
            </div>
          </div>

          <h3>Drop your Excel file here</h3>

          <p>
            or <strong>browse your computer</strong>
          </p>

          <div class="file-rules">

            <span>
              <i class="fa-solid fa-check"></i>
              XLSX format
            </span>

            <span>
              <i class="fa-solid fa-shield-halved"></i>
              Secure processing
            </span>

          </div>

        </div>

      </div>


      <!-- Class selector -->
      <div class="collection-panel">

        <div class="panel-heading">

          <div class="heading-icon purple">
            <i class="fa-solid fa-layer-group"></i>
          </div>

          <div>
            <!-- <span>DOCUMENT COLLECTION</span> -->
            <h2>Select Document Folder</h2>
            <p>
              Choose the document collection.
            </p>
          </div>

        </div>


        <div class="collection-form">

          <label>
            Document collection
          </label>

          @if (showDropdown) {

            <p-dropdown
              [options]="elibraryList"
              [(ngModel)]="selectedClassList"
              optionLabel="full_name"
              placeholder="Select collection"
              (onChange)="dropdownSelectedClass($event)"
              class="class-dropdown"
            >
            </p-dropdown>

          }


          <div class="helper-message">

            <i class="fa-solid fa-circle-info"></i>

            <span>
              Select a collection to load its available documents.
            </span>

          </div>


          @if (selectedClassList) {

            <div class="selected-collection">

              <div class="collection-folder">
                <i class="fa-solid fa-folder"></i>
              </div>

              <div>
                <span>Current collection</span>

                <strong>
                  {{ selectedClassList.full_name }}
                </strong>
              </div>

              <i class="fa-solid fa-check-circle"></i>

            </div>

          }

        </div>

      </div>

    </section>


    <!-- =======================================================
         DOCUMENT WORKSPACE
    ======================================================== -->
    @if (selectedClassList) {

      <section class="workspace-panel">

        <div class="workspace-panel-header">

          <div>
            <span class="section-label">DOCUMENT LIBRARY</span>

            <h2>
              Select documents
            </h2>

            <p>
              Choose the documents that should be used for this Excel Q&A.
            </p>
          </div>


          <label class="select-all">

            <input
              type="checkbox"
              id="select_all"
              [checked]="selectAll"
              (change)="toggleSelectAll()"
            />

            <span class="checkbox"></span>

            <strong>Select all</strong>

          </label>

        </div>


        @if (documentListLoading) {

          <div class="loading-state">

            <div class="loading-ring"></div>

            <h3>Loading documents</h3>

            <p>
              Fetching available documents...
            </p>

          </div>

        }


        @if (!documentListLoading && documentList.length > 0) {

          <div class="document-layout">

            @for (
              item of documentList;
              track item.message_id
            ) {

              <article
                class="document-tile"
                [class.selected]="isDocumentSelected(item)"
              >

                <div class="tile-header">

                  <label class="document-checkbox">

                    <input
                      type="checkbox"
                      [id]="'document_' + item.message_id"
                      [checked]="isDocumentSelected(item)"
                      (change)="toggleDocumentSelection(item)"
                    />

                    <span></span>

                  </label>

                  <span class="document-format">
                    PDF
                  </span>

                </div>


                <div class="document-image">
                  <img
                    src="../../../../assets/images/file_types/pdf.png"
                    alt="PDF"
                  />
                </div>


                <div class="document-title">

                  <h3 [title]="getDocumentTitle(item)">
                    {{
                      getDocumentTitle(item) || "Untitled document"
                    }}
                  </h3>

                  <div class="document-owner">

                    <i class="fa-regular fa-user"></i>

                    <span>
                      {{ item.shared_by || "Unknown" }}
                    </span>

                  </div>

                </div>


                <div class="document-bottom">

                  <span>
                    <i class="fa-regular fa-calendar"></i>
                    {{ item.created_at | date : "MMM d, y" }}
                  </span>

                  <span class="document-available">
                    Available
                  </span>

                </div>

              </article>

            }

          </div>

        }


        @if (!documentListLoading && documentList.length === 0) {

          <div class="empty-state">

            <div class="empty-symbol">
              <i class="fa-regular fa-folder-open"></i>
            </div>

            <h3>No documents available</h3>

            <p>
              This collection does not contain any documents yet.
            </p>

          </div>

        }

      </section>

    }


    <!-- =======================================================
         COLUMN CONFIGURATION
    ======================================================== -->
    @if (showsheetform) {

      <section class="workspace-panel">

        <div class="workspace-panel-header mapping-header">

          <div>

            <span class="section-label">
              EXCEL CONFIGURATION
            </span>

            <h2>
              Map your columns
            </h2>

            <p>
              Define which columns contain the questions and answers.
            </p>

          </div>

          <div class="mapping-tip">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            Required fields
          </div>

        </div>


        <form [formGroup]="excelSheetForm">

          <div
            class="mapping-table"
            formArrayName="sheets"
          >

            <div class="mapping-table-head">

              <span>Excel sheet</span>
              <span>Question column</span>
              <span>Answer column</span>
              <span></span>

            </div>


            @for (
              skill of skills.controls;
              track skill;
              let i = $index
            ) {

              <div
                class="mapping-table-row"
                [formGroupName]="i"
              >

                <div class="sheet-name">

                  <div class="sheet-icon">
                    <i class="fa-solid fa-file-excel"></i>
                  </div>

                  <div>
                    <span>Sheet</span>

                    <strong>
                      {{ skill.get("sheet_name")?.value }}
                    </strong>
                  </div>

                </div>


                <div class="mapping-select">

                  <label>
                    Question
                    <em>*</em>
                  </label>

                  <div>

                    <select
                      formControlName="question_field"
                      required
                    >

                      @for (
                        items of sheetslist[i]?.columns;
                        track items
                      ) {

                        <option [value]="items">
                          {{ items }}
                        </option>

                      }

                    </select>

                    <i class="fa-solid fa-chevron-down"></i>

                  </div>

                </div>


                <div class="mapping-select">

                  <label>
                    Answer
                    <em>*</em>
                  </label>

                  <div>

                    <select
                      formControlName="answer_field"
                      required
                    >

                      @for (
                        items of sheetslist[i]?.columns;
                        track items
                      ) {

                        <option [value]="items">
                          {{ items }}
                        </option>

                      }

                    </select>

                    <i class="fa-solid fa-chevron-down"></i>

                  </div>

                </div>


                <button
                  type="button"
                  class="delete-sheet"
                  title="Remove sheet"
                  (click)="removeSkill(i)"
                >
                  <i class="fa-solid fa-trash-can"></i>
                </button>

              </div>

            }

          </div>


          <div class="panel-footer">

            <button
              type="button"
              class="primary-action"
              (click)="onSubmit()"
            >

              <i class="fa-solid fa-check"></i>

              <span>Save mapping</span>

              <i class="fa-solid fa-arrow-right"></i>

            </button>

          </div>

        </form>

      </section>

    }


    <!-- =======================================================
         RESULTS
    ======================================================== -->
    @if (showsheetDataList) {

      <section class="workspace-panel results-panel">

        <div class="workspace-panel-header">

          <div>

            <span class="section-label">
              REVIEW
            </span>

            <h2>
              Question & Answer
            </h2>

            <p>
              Review the imported data before downloading.
            </p>

          </div>

        </div>


        <div class="results-list">

          @if (sheetDataList.length > 0) {

            @for (
              list of sheetDataList;
              track list.sheet_name;
              let i = $index
            ) {

              <div class="sheet-block">

                <button
                  type="button"
                  class="sheet-block-header"
                  (click)="toggleSheet(i)"
                >

                  <div class="sheet-block-title">

                    <div class="sheet-result-icon">
                      <i class="fa-solid fa-file-excel"></i>
                    </div>

                    <div>
                      <span>Excel sheet</span>

                      <strong>
                        {{ list["sheet_name"] }}
                      </strong>
                    </div>

                  </div>


                  <div class="sheet-chevron">

                    <i
                      class="fa-solid"
                      [class.fa-chevron-down]="!list.expanded"
                      [class.fa-chevron-up]="list.expanded"
                    ></i>

                  </div>

                </button>


                @if (list.expanded) {

                  <div class="qa-list">

                    @for (
                      data of list['sheet_data'];
                      track data
                    ) {

                      @if (data['question']) {

                        <div class="qa-card">

                          <div class="qa-question">

                            <div class="qa-label">
                              <span>
                                <i class="fa-solid fa-circle-question"></i>
                              </span>

                              Question
                            </div>

                            <p>
                              {{ data["question"] }}
                            </p>

                          </div>


                          <div class="qa-divider">
                            <i class="fa-solid fa-arrow-right"></i>
                          </div>


                          <div class="qa-answer">

                            <div class="qa-label">
                              <span>
                                <i class="fa-solid fa-circle-check"></i>
                              </span>

                              Answer
                            </div>

                            <p>
                              {{ data["answer"] }}
                            </p>

                          </div>

                        </div>

                      }

                    }

                  </div>

                }

              </div>

            }

          }


          @else {

            <div class="empty-state">

              <div class="empty-symbol">
                <i class="fa-solid fa-table"></i>
              </div>

              <h3>No Q&A data</h3>

              <p>
                There are no question and answer records to display.
              </p>

            </div>

          }

        </div>


        <div class="panel-footer">

          <button
            type="button"
            class="secondary-action"
            (click)="closeSheet()"
          >
            <i class="fa-solid fa-xmark"></i>
            Close
          </button>

          <button
            type="button"
            class="download-action"
            (click)="downloadSheet()"
          >
            <i class="fa-solid fa-download"></i>
            Download Excel
          </button>

        </div>

      </section>

    }

  </main>


  <!-- =========================================================
       HISTORY OVERLAY
  ========================================================== -->
  @if (showHistory) {

    <div
      class="history-overlay"
      (click)="toggleHistory()"
    ></div>

  }


  <!-- =========================================================
       HISTORY DRAWER
  ========================================================== -->
  <aside
    class="history-drawer"
    [class.open]="showHistory"
  >

    <div class="history-top">

      <div class="history-title">

        <div class="history-title-icon">
          <i class="fa-solid fa-clock-rotate-left"></i>
        </div>

        <div>
          <h2>History</h2>
          <p>Previously downloaded files</p>
        </div>

      </div>


      <button
        type="button"
        class="history-close"
        (click)="toggleHistory()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>


    <div class="history-search">

      <i class="fa-solid fa-magnifying-glass"></i>

      <input
        type="text"
        placeholder="Search files..."
        [(ngModel)]="historySearchText"
        (input)="filterHistory()"
      />

      @if (historySearchText !== '') {

        <button
          type="button"
          (click)="historySearchText = ''; filterHistory()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>

      }

    </div>


    <div class="history-content">

      @if (historyLoading) {

        <div class="history-loading">

          <div class="loading-ring"></div>

          <p>Loading history...</p>

        </div>

      }


      @if (
        !historyLoading &&
        filteredHistoryList.length > 0
      ) {

        @for (
          item of filteredHistoryList;
          track item;
          let i = $index
        ) {

          <div class="history-row">

            <div
              class="history-file"
              (click)="viewHistoryItem(item)"
              [pTooltip]="item.file_name"
            >

              <div class="history-excel-icon">
                <i class="fa-solid fa-file-excel"></i>
              </div>

              <div class="history-file-text">

                <strong>
                  {{ item.file_name || "Untitled File" }}
                </strong>

                <span>
                  Excel document
                </span>

              </div>

            </div>


            <button
              type="button"
              class="history-delete"
              title="Delete"
              (click)="
                deleteHistoryItem(item, i);
                $event.stopPropagation()
              "
            >
              <i class="fa-solid fa-trash-can"></i>
            </button>

          </div>

        }

      }


      @if (
        !historyLoading &&
        filteredHistoryList.length === 0
      ) {

        <div class="history-empty">

          <div>
            <i class="fa-regular fa-folder-open"></i>
          </div>

          <h3>No history found</h3>

          <p>
            Downloaded Excel files will appear here.
          </p>

        </div>

      }

    </div>

  </aside>


  <!-- =========================================================
       GLOBAL PROCESSING
  ========================================================== -->
  @if (showPaginateSpinner) {

    <div class="processing-overlay">

      <div class="processing-card">

        <div class="processing-icon">
          <i class="fa-solid fa-file-excel"></i>
        </div>

        <div class="processing-loader"></div>

        <h3>Processing Excel</h3>

        <p>
          Please wait while we process your file.
        </p>

      </div>

    </div>

  }

</div>
